import { createRouter, createWebHistory } from 'vue-router'
import { isAuthenticated } from '../lib/auth'

const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    {
      path: '/connexion',
      name: 'login',
      component: () => import('../views/LoginPage.vue'),
      meta: { public: true },
    },
    {
      path: '/erreurs/400',
      name: 'error-400',
      component: () => import('../views/ErrorPage.vue'),
      props: { code: 400 },
      meta: { public: true },
    },
    {
      path: '/erreurs/403',
      name: 'error-403',
      component: () => import('../views/ErrorPage.vue'),
      props: { code: 403 },
      meta: { public: true },
    },
    {
      path: '/erreurs/500',
      name: 'error-500',
      component: () => import('../views/ErrorPage.vue'),
      props: { code: 500 },
      meta: { public: true },
    },
    {
      path: '/erreurs/404',
      name: 'error-404',
      component: () => import('../views/ErrorPage.vue'),
      props: { code: 404 },
      meta: { public: true },
    },

    // ── Layout admin ──────────────────────────────────────────
    {
      path: '/',
      component: () => import('../components/layout/AdminLayout.vue'),
      children: [
        {
          path: '',
          redirect: '/tableau-de-bord',
        },
        {
          path: 'tableau-de-bord',
          name: 'dashboard',
          component: () => import('../views/DashboardPage.vue'),
        },

        // ── Utilisateurs ──────────────────────────────────────
        {
          path: 'utilisateurs',
          name: 'users',
          component: () => import('../views/users/UsersListPage.vue'),
        },
        {
          path: 'utilisateurs/:id',
          name: 'user-detail',
          component: () => import('../views/users/UserDetailPage.vue'),
        },
        {
          path: 'entreprises',
          name: 'companies',
          component: () => import('../views/companies/CompaniesPage.vue'),
        },
        {
          path: 'secteurs',
          name: 'sectors',
          component: () => import('../views/SectorsPage.vue'),
        },
        {
          path: 'parametres/contact',
          name: 'company-contact-settings',
          component: () => import('../views/settings/CompanyContactPage.vue'),
        },

        // ── Enquêtes ──────────────────────────────────────────
        {
          path: 'enquetes',
          name: 'surveys',
          component: () => import('../views/surveys/SurveysListPage.vue'),
        },
        {
          path: 'enquetes/creer',
          name: 'survey-create',
          component: () => import('../views/surveys/SurveyCreatePage.vue'),
        },
        {
          path: 'enquetes/:id',
          name: 'survey-detail',
          component: () => import('../views/surveys/SurveyDetailPage.vue'),
        },
        {
          path: 'enquetes/:id/modifier',
          name: 'survey-edit',
          component: () => import('../views/surveys/SurveyCreatePage.vue'),
        },

        // ── Rapports ──────────────────────────────────────────
        {
          path: 'rapports',
          name: 'reports',
          component: () => import('../views/ReportsPage.vue'),
        },

        // ── Articles ──────────────────────────────────────────
        {
          path: 'articles',
          name: 'articles',
          component: () => import('../views/articles/ArticlesListPage.vue'),
        },
        {
          path: 'articles/creer',
          name: 'article-create',
          component: () => import('../views/articles/ArticleEditPage.vue'),
        },
        {
          path: 'articles/:id/modifier',
          name: 'article-edit',
          component: () => import('../views/articles/ArticleEditPage.vue'),
        },

        // ── Services ──────────────────────────────────────────
        {
          path: 'services',
          name: 'services',
          component: () => import('../views/services/ServicesListPage.vue'),
        },
        {
          path: 'services/nouveau',
          name: 'service-create',
          component: () => import('../views/services/ServiceEditPage.vue'),
        },
        {
          path: 'services/:id/modifier',
          name: 'service-edit',
          component: () => import('../views/services/ServiceEditPage.vue'),
        },

        // ── Homepage ─────────────────────────────────────────
        {
          path: 'homepage/donnees-economiques',
          name: 'homepage-economic-indicators',
          component: () => import('../views/homepage/EconomicIndicatorsListPage.vue'),
        },
        {
          path: 'homepage/donnees-economiques/nouveau',
          name: 'homepage-economic-indicator-create',
          component: () => import('../views/homepage/EconomicIndicatorEditPage.vue'),
        },
        {
          path: 'homepage/donnees-economiques/:id/modifier',
          name: 'homepage-economic-indicator-edit',
          component: () => import('../views/homepage/EconomicIndicatorEditPage.vue'),
        },
        {
          path: 'homepage/statistiques',
          name: 'homepage-stats',
          component: () => import('../views/homepage/HomepageStatsListPage.vue'),
        },
        {
          path: 'homepage/statistiques/nouveau',
          name: 'homepage-stat-create',
          component: () => import('../views/homepage/HomepageStatEditPage.vue'),
        },
        {
          path: 'homepage/statistiques/:id/modifier',
          name: 'homepage-stat-edit',
          component: () => import('../views/homepage/HomepageStatEditPage.vue'),
        },
        {
          path: 'homepage/a-propos',
          name: 'homepage-about',
          component: () => import('../views/homepage/HomepageAboutPage.vue'),
        },

        // ── Audit ─────────────────────────────────────────────
        {
          path: 'audit',
          name: 'audit',
          component: () => import('../views/AuditPage.vue'),
        },
      ],
    },

    // 404
    {
      path: '/:pathMatch(.*)*',
      redirect: '/erreurs/404',
    },
  ],
})

router.beforeEach((to) => {
  if (to.meta.public) return true
  if (!isAuthenticated()) return { name: 'login' }
  return true
})

export default router
